module.exports = __webpack_public_path__ + "static/img/pk-jg-active.cb9bb185.png";